import ActionsListComponent from './ActionsListComponent';

export default ActionsListComponent;
